import { FormHTMLAttributes, PropsWithChildren } from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from 'react-hook-form';

interface IForm extends PropsWithChildren<FormHTMLAttributes<HTMLFormElement>> {
  readonly formSubmit: SubmitHandler<FieldValues>;
  readonly options?: FieldValues;
}
const Form = ({ children, formSubmit, options, ...rest }: IForm) => {
  const methods = useForm(options);

  return (
    <FormProvider {...methods}>
      <form {...rest} onSubmit={methods.handleSubmit(formSubmit)}>
        {children}
      </form>
    </FormProvider>
  );
};

export default Form;
